__turbopack_context__.v({
  "callout-body": "style-module-scss-module__0lcroq__callout-body",
  "callout-header": "style-module-scss-module__0lcroq__callout-header",
  "callout-root": "style-module-scss-module__0lcroq__callout-root",
  "callout-root--hybrid": "style-module-scss-module__0lcroq__callout-root--hybrid",
  "close": "style-module-scss-module__0lcroq__close",
  "scale-and-fadein": "style-module-scss-module__0lcroq__scale-and-fadein",
  "wrapper": "style-module-scss-module__0lcroq__wrapper",
  "zoocasa-theme": "style-module-scss-module__0lcroq__zoocasa-theme",
});
